<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
            <div class="col-12  mt-2 py-0">
              <h4 class="m-0 p-0 text-secondary d-inline">Data Pengguna</h4>
              <button class="float-right btn btn-primary shadow mt-2" v-on:click="formNewUserActive=!formNewUserActive">Tambah Pengguna Baru</button>
            </div>
            <transition name="fade">
            <div class="col-12  my-2 py-0" v-if="formNewUserActive">
                <div class="row p-3 mx-2 bg-white shadow">
                    <div class="col-12 mb-3">
                        <h4 class="my-0 py-0">Form Pengguna Baru</h4>
                        <hr>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label class="d-block">Role <span style="color:red;">*</span></label>
                        <smart-select name="user_role" :default-value="translateRole(newUser.role)" :options="userRoleOptions" v-on:update="updateUserRoleValue"></smart-select>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label class="d-block">Nama <span style="color:red;">*</span></label>
                        <input type="text"  class="form-control w-100 rounded" v-model="newUser.name" />
                        <small class="text-danger" v-show="isAddName">Harap isi nama</small>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label class="d-block">Username <span style="color:red;">*</span></label>
                        <input type="text" class="form-control w-100 rounded" v-model="newUser.username" v-on:input="newUsernameChange" />
                        <small class="text-danger" v-show="isAddUsername">Harap isi username</small>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label class="d-block" for="password">Password <span style="color:red;">*</span></label>
                        <input id="password" :type="[passVisible?'text':'password']" name="password" class="form-control w-100 rounded" v-model="newUser.password" />
                        <div class="w-100 text-right"><a href="#" class="text-secondary" v-on:click="passVisible=!passVisible" ><i class="fa field-icon" :class="[passVisible ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i></a></div>
                        <small class="text-danger" v-show="isAddPassword">Harap isi password</small>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="newUserSaved">
                            <div class="alert alert-success" role="alert">
                                Berhasil menyimpan Pengguna baru.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 w-100 my-3" v-if="newUser.role=='client'">
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <button class="nav-link" :class="[selectedTab==0?'active':'']" href="#" v-on:click="selectedTab=0;newUser.clientType='existing'">Pelanggan Yang Sudah Ada</button>
                            </li>
                            <li class="nav-item">
                                <button class="nav-link" :class="[selectedTab==1?'active':'']" href="#" v-on:click="selectedTab=1;newUser.clientType='new'">Pelanggan Baru</button>
                            </li>
                        </ul>
                        <!-- cari existing client -->
                        <div class="w-100" v-if="selectedTab==0">
                            <h4>Cari Pelanggan Berdasarkan Nama Pelanggan</h4>
                            <div class="row">
                                <div class="col-md-4 col-12 mt-1">
                                    <label class="d-block">Nama</label>
                                    <input type="text" class="form-control shadow-sm" placeholder="Masukan Nama Pelanggan" v-model="existingClientQuery.firstNameClientQuery" v-on:input="searchExistingClientChangeEvent" />
                                </div>
                                <div class="col-md-4 col-12 mt-1">
                                    <label class="d-block">Nama Belakang</label>
                                    <input type="text" class="form-control shadow-sm" placeholder="Masukan Nama Belakang Pelanggan" v-model="existingClientQuery.lastNameClientQuery" v-on:input="searchExistingClientChangeEvent" />
                                </div>
                                <div class="col-md-4 col-12 mt-1">
                                    <label class="d-block">Nama Legal</label>
                                    <input type="text" class="form-control shadow-sm" placeholder="Masukan Nama Belakang Pelanggan" v-model="existingClientQuery.legalNameClientQuery" v-on:input="searchExistingClientChangeEvent"/>
                                </div>
                                <div class="col-12 my-3" v-if="existingClientQuery.nextQueue || existingClientQuery.looking">
                                    <div class="d-flex align-items-center justify-content-start">
                                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                                        <strong class=" ml-2">Mencari data</strong>
                                    </div>
                                </div>
                                <div class="col-12 my-3" v-if="!existingClientQuery.nextQueue && !existingClientQuery.looking && existingClientResult.length>0 && (existingClientQuery.firstNameClientQuery!='' || existingClientQuery.lastNameClientQuery!='' || existingClientQuery.legalNameClientQuery!='')">
                                    <b>Hasil pencarian</b>
                                    <div class="w-100 py-2 px-3 my-2 shadow-sm pointer rounded" v-on:click="setNewClientId(client.id,client)" :class="[(client.id==newUser.clientId)?'bg-primary text-white':'']" v-for="client in existingClientResult" v-bind:key="client">{{client.first_name}} {{client.last_name}}, {{client.legal_name}}, {{client.telephone_pemilik}}</div>
                                </div>
                                <div class="col-12 my-3" v-if="!existingClientQuery.nextQueue && !existingClientQuery.looking && existingClientResult.length<1 && (existingClientQuery.firstNameClientQuery!='' || existingClientQuery.lastNameClientQuery!='' || existingClientQuery.legalNameClientQuery!='')">
                                    <b>Hasil Pencarian</b>
                                    <p>Tidak Ada Aata Yang Ditemukan.</p>
                                </div>
                            </div>
                            
                        </div>
                        <!-- field new client -->
                        <div class="w-100" v-if="selectedTab==1">
                            <div class="row mt-3">
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Tipe Pelanggan <span style="color:red;">*</span></label>
                                    <smart-select name="client_type" :options="newClientOption.clientTypes" v-on:update="updateClientType"></smart-select>
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">ID Pelanggan <span style="color:red;">*</span></label>
                                    <input type="number"  class="form-control w-100 rounded" :min="3" :max="5" v-model="newUser.newClient.IdKlien" />
                                    <small class="text-danger" v-show="isAddIdKlienLength">ID Pelanggan Minimum 3 Digit</small>
                                    <small class="text-danger" v-show="isAddIdKlien">Harap isi username</small>
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Nama <span style="color:red;">*</span></label>
                                    <input type="text"  class="form-control w-100 rounded" v-model="newUser.newClient.firstName" @input="autoFillLegalName" />
                                </div>
                                <div cclass="mt-4 col-12 col-md-6 col-lg-4" v-if="isNewBadan">
                                    <label class="d-block">Nama Belakang</label>
                                    <input type="text"  class="form-control w-100 rounded" v-model="newUser.newClient.lastName" @input="autoFillLegalName" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Nama Legal <span style="color:red;">*</span></label>
                                    <input type="text"  class="form-control w-100 rounded" v-model="newUser.newClient.legalName" readonly/>
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Telp Pemilik</label>
                                    <input type="number"  class="form-control w-100 rounded" v-model="newUser.newClient.telephonePemilik" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Tambah Phone</label>
                                    <input type="number"  class="form-control w-100 rounded" v-model="newUser.newClient.telephoneSecondaryPemilik" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Telp Pemilik (PIC)</label>
                                    <input type="number"  class="form-control w-100 rounded" v-model="newUser.newClient.telephonePengurus" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Email</label>
                                    <input type="email"  class="form-control w-100 rounded" v-model="newUser.newClient.email" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">NPWP</label>
                                    <input type="text" id="newNPWP" class="form-control w-100 rounded" v-model="newUser.newClient.npwp" @input="convertNewNPWP"/>
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Identitas Penanggung Jawab</label>
                                    <smart-select name="client_identity" :options="newClientOption.identityTypes" v-on:update="updateClientIdentityType"></smart-select>
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">No Identitas Penanggung Jawab</label>
                                    <input type="number" :min="1" :max="16" class="form-control w-100 rounded" v-model="newUser.newClient.identityNo" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">SIUP</label>
                                    <input type="text"  class="form-control w-100 rounded" v-model="newUser.newClient.siup" />
                                </div>
                                <div class="mt-4 col-12 col-md-6 col-lg-4">
                                    <label class="d-block">Alamat</label>
                                    <textarea type="text"  class="form-control w-100 rounded" v-model="newUser.newClient.address" />
                                </div>
                                <!-- <div class="mt-2" :class="newClientCol"  md="6" lg="4">
                                    <label class="d-block">Tipe induk</label>
                                    <smart-select name="client_induk" :options="newClientOption.clientTypes" v-on:update="updateClientIndukType"></smart-select>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="w-100 align-items-center justify-content-start" v-if="errorNewUser">
                            <div class="alert alert-danger" role="alert">
                                <div class="my-0">
                                    <p  class="d-block mt-1">Gagal menyimpan pengguna baru.</p>
                                </div>
                                <div v-for="err in errorNewUserList" v-bind:key="err" class="my-0">
                                    <p  v-for="note in err" v-bind:key="note" class="d-block mt-1">{{note}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="d-flex align-items-center justify-content-start" v-if="savingNewPengguna">
                            <div class="spinner-border" role="status" aria-hidden="true"></div>
                            <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                        </div>
                        <button class="btn btn-primary float-right" type="button" v-on:click="saveNewUser">Submit</button>
                    </div>
                </div>
            </div>
            </transition>

        
          <div class="col-12  my-2 py-0">
            <datatable :datas="users" :structure="userTableStructure" :init="loadData" :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"  use-seeker seeker-url="/api/master/seeker/user" @searching="(val)=>!val.status?getUsers():users=val.data">
                <template #customcell={obj,index}>
                    <td v-if="isMobile" class="py-3">
                        <ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
                            <li class="mt-2">
                                <div class="text-left mx-3">
                                    <small class="my-0 py-0">Nama:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.name}}</b>
                                </div>
                                <hr class="my-2">
                            </li>
                            <li>
                                <div class="text-left mx-3">
                                    <small class="my-0 py-0">Role:</small>
                                    <br><b class="py-0 mx-0" style="font-size:10pt">{{ translateRole(obj.role) }}</b>
                                </div>
                            </li>
                            <li>
                                <hr>
                                <div class="text-left mx-3">
                                    <b-button v-b-modal.modal-detail-pengguna class="btn btn-primary mb-1 mr-2" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                                    <b-button v-b-modal.modal-edit-user class="btn btn-info mb-1 mr-2" v-on:click="selectedClient=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                                    <b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mb-1 mr-2"><b-icon icon="trash"></b-icon></b-button>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="!isMobile">{{ index+ 1 }}</td>
                    <td v-if="!isMobile">{{ obj.name }}</td>
                    <td v-if="!isMobile">{{ obj.client&&obj.client.legal_name!=null?obj.client.legal_name:'-' }}</td>
                    <td v-if="!isMobile">{{ translateRole(obj.role) }}</td>
                    <td v-if="!isMobile">
                        <b-button title="View" v-b-modal.modal-detail-pengguna class="btn btn-primary mb-1 mr-2" v-on:click="selectedDetail=index"><b-icon icon="eye"></b-icon></b-button>
                        <b-button title="Edit" v-b-modal.modal-edit-user class="btn btn-info mb-1 mr-2" v-on:click="selectedClient=index;dataEdit=Object.assign({},obj)"><b-icon icon="pencil-square"></b-icon></b-button>
                        <b-button title="Delete" v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" class="btn btn-danger mb-1 mr-2"><b-icon icon="trash"></b-icon></b-button>
                    </td>
                </template>
            </datatable>
          </div>

      </div>
    </div>

    <!-- MODAL CLIENT -->
    <!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-user" title="Konfirmasi hapus data pengguna" scrollable no-close-on-backdrop @hide="deleteModalClose">
        <b-container fluid v-if="!loadData">
            <b-row class="pt-1">
              <b-col cols="12" class="my-3">
                  <h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
                  <ul>
                      <li>Name: {{users[selectedToDelete].name}}</li>
                      <li>Username: {{users[selectedToDelete].username}}</li>
                      <li>Role: {{users[selectedToDelete].role}}</li>
                  </ul>
              </b-col>
               <b-col cols="12" class="my-3 text-right"  v-if="deleteUserState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="userDeleted">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil menghapus data Pelanggan.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="failDeleteUser">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal menghapus data Pelanggan.
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <button class="btn btn-danger  mr-2" v-on:click="deleteClientData">Ya, hapus</button>
            <b-button class="btn btn-secondary" @click="(!deleteUserState)?$bvModal.hide('modal-delete-user'):''">Tutup</b-button>
            </div>
        </template>
    </b-modal> -->
    <b-modal no-close-on-esc  content-class="m-0"  title="Detail Informasi" id="modal-detail-pengguna" scrollable no-close-on-backdrop @hide="detailModalClose">
        <b-container fluid v-if="!loadData&&users.length>0">
            <b-row class="pt-1" v-if="users[selectedDetail]!=undefined">
            <b-col cols="12">
                    <table v-if="users.length>0" rules="rows" class="table w-100" style="overflow-x:auto;">
                        <tbody>
                            <tr>
                                <th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2" scope="row">Detail Pengguna</th>
                            </tr>
                            <tr>
                                <th class="" scope="row">Role</th>
                                <td class="">{{translateRole(users[selectedDetail].role)}}</td>
                            </tr>
                            <tr>
                                <th class="" scope="row">Username</th>
                                <td class="">{{users[selectedDetail].username}}</td>
                                <!-- <td class="">{{users[selectedDetail].hardware_setup!=null?users[selectedDetail].hardware_setup.id_transmitter:'-'}}</td> -->
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Tipe Pelanggan</th>
                                <td class="">{{users[selectedDetail].client?users[selectedDetail].client.type=="Badan"?"Non Perorangan":users[selectedDetail].client.type:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">ID Pelanggan</th>
                                <td class="">{{users[selectedDetail].client?users[selectedDetail].client.customer_id:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Nama</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.first_name!=null?users[selectedDetail].client.first_name:'-'}}</td>
                                <!-- <td class="">{{ users[selectedDetail].client?users[selectedDetail].client.legal_name!=null?users[selectedDetail].client.legal_name:'-':'-'}}</td> -->
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Nama Belakang</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.last_name!=null?users[selectedDetail].client.last_name:'-'}}</td>
                                <!-- <td class="">{{ users[selectedDetail].client?users[selectedDetail].client.legal_name!=null?users[selectedDetail].client.legal_name:'-':'-'}}</td> -->
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Nama Legal</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.legal_name!=null?users[selectedDetail].client.legal_name:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Telp Pemilik</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.telephone_pemilik!=null?users[selectedDetail].client.telephone_pemilik:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Tambah Phone</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.telephone_pemilik_secondary!=null?users[selectedDetail].client.telephone_pemilik_secondary:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Telp Pemilik (PIC)</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.telephone_pengurus!=null?users[selectedDetail].client.telephone_pengurus:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Email</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.email!=null?users[selectedDetail].client.email:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">NPWP</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.npwp!=null?users[selectedDetail].client.npwp:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">SIUP</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.siup!=null?users[selectedDetail].client.siup:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Identitas Penanggung Jawab</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.identity!=null?users[selectedDetail].client.identity:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">No Identitas Penanggung Jawab</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.identity_no!=null?users[selectedDetail].client.identity_no:'-'}}</td>
                            </tr>
                            <tr  v-if="['client','supervisor'].includes(users[selectedDetail].role)">
                                <th class="" scope="row">Alamat</th>
                                <td class="">{{users[selectedDetail].client&&users[selectedDetail].client.address!=null?users[selectedDetail].client.address:'-'}}</td>
                            </tr>
                            
                        </tbody>
                        
                    </table>
            </b-col>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <b-button class="btn btn-secondary" @click="(!deleteUserState)?$bvModal.hide('modal-detail-pengguna'):''">Tutup</b-button>
            </div>
        </template>
    </b-modal>

    <b-modal no-close-on-esc  content-class="m-0"  id="modal-edit-user" title="Detail informasi user" scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
        <b-container fluid v-if="!loadData && dataEdit!=null">
            <b-row class="pt-1" v-if="users[selectedClient]!=undefined">
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block">Nama</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].name" /> 
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block">Password</label>
                    <input id="password" :type="[passVisibleEdit?'text':'password']" class="form-control w-100 rounded" v-model="users[selectedClient].password" />
                    <div class="w-100 text-left pt-2"><a href="#" class="text-secondary" v-on:click="passVisibleEdit=!passVisibleEdit" ><i class="fa field-icon-update" :class="[passVisibleEdit ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="true"></i></a></div>
                    <small class="text-danger" v-show="isEditPasswordLength">Password minimum 6 digit</small>
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block">Role</label>
                    <!-- <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].role" /> -->
                    <!-- <smart-select name="role" :options="newClientOption.roleTypes" v-on:update="(value)=>{users[selectedClient].client.role=value}"></smart-select> -->
                    <smart-select name="role" :options="userRoleOptions" usedefault :default-value="translateRole(users[selectedClient].role)" v-on:update="(value)=>{users[selectedClient].role=value}"></smart-select>
                        
                </b-col>
                
                <b-col cols="12" class="my-3 text-right"  v-if="updateUserState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="updateUserSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil update data pengguna.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="errorUserSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal update data pengguna.
                        </div>
                    </div>
                </div>
                <b-col cols="12" class="my-3 text-right">
                    <button class="btn btn-info" v-on:click="updateUserData">Simpan</button>
                </b-col>
            </b-row>
            <b-row v-if="users[selectedClient]!=undefined&&users[selectedClient].role=='client' && users[selectedClient].client!=null" class="mt-3 pb-1">
                <b-col cols="12">
                  <hr>
                </b-col>
                <b-col cols="12">
                  <h4>Informasi Pengguna</h4>
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Tipe Pelanggan</label>
                    <smart-select name="client_type" usedefault :default-value="users[selectedClient].client.type" :options="newClientOption.clientTypes" v-on:update="(value)=>{users[selectedClient].client.type=value}"></smart-select>
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                        <label class="d-block mt-2">ID Pelanggan</label>
                        <input type="number"  class="form-control w-100 rounded" v-model="users[selectedClient].client.customer_id" />
                        <small class="text-danger" v-show="isEditIdKlienLength">ID Pelanggan Minimum 3 Digit</small>
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                        <label class="d-block mt-2">Nama</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.first_name" /> 
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                        <label class="d-block mt-2">Nama Belakang</label>
                        <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.last_name" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Nama Legal</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.legal_name" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Telp Pemilik</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="users[selectedClient].client.telephone_pemilik" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Tambah Phone</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="users[selectedClient].client.telephone_pemilik_secondary" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Telp Pemilik (PIC)</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="users[selectedClient].client.telephone_pengurus" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Email</label>
                    <input type="email"  class="form-control w-100 rounded" v-model="users[selectedClient].client.email" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">NPWP</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.npwp" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Identitas Penanggung Jawab</label>
                    <smart-select name="client_identity" :options="newClientOption.identityTypes" v-on:update="(value)=>{users[selectedClient].client.identity=value}"></smart-select>
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">No Identitas Penanggung Jawab</label>
                    <input type="number"  class="form-control w-100 rounded" v-model="users[selectedClient].client.identity_no" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">SIUP</label>
                    <input type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.siup" />
                </b-col>
                <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block mt-2">Alamat</label>
                    <textarea type="text"  class="form-control w-100 rounded" v-model="users[selectedClient].client.address" />
                </b-col>
                <!-- <b-col :cols="updateClientCol"  md="6" lg="4">
                    <label class="d-block">Tipe induk</label>
                    <smart-select name="client_induk" :options="newClientOption.clientTypes" v-on:update="(value)=>{users[selectedClient].client.induk=value}"></smart-select>
                </b-col> -->
                <b-col cols="12" class="my-3 text-right"  v-if="updateClientState">
                   <div class="d-flex align-items-center justify-content-start">
                        <div class="spinner-border" role="status" aria-hidden="true"></div>
                        <strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
                    </div>
                </b-col>
                <div class="col-12 mt-3"  v-if="updateClientSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-success" role="alert">
                            Berhasil update data Pelanggan.
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3"  v-if="errorClientSaved">
                    <div class="w-100 align-items-center justify-content-start">
                        <div class="alert alert-danger" role="alert">
                            Gagal update data Pelanggan.
                        </div>
                    </div>
                </div>
                <b-col cols="12" class="my-3 text-right">
                    <button class="btn btn-info" v-on:click="updateClientData">Simpan</button>
                </b-col>
            </b-row>
        </b-container>
        <template #modal-footer>
            <div class="w-100 text-right m-0 p-0">
            <hr>
            <b-button class="btn btn-secondary mr-2" @click="(!updateUserState&&!updateClientState)?$bvModal.hide('modal-edit-user'):''">Tutup</b-button>
            <!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
            </div>
        </template>
  </b-modal>

    <modal-delete url="/api/master/pengguna/" @read="()=>{console.log('modal ready')}" @result="deleteResult" :targetid="deleteId">
    Yakin mau menghapus data dengan detail berikut :<br>
    <ul>
        <li>Username: {{ itemToDelete.username }}</li>
        <!-- <li>Nama Legal: {{ itemToDelete.client.legal_name }}</li> -->
        <li>Role : {{ translateRole(itemToDelete.role) }}</li>
    </ul>
    </modal-delete>

  </div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
    import * as axios from 'axios';
    import Datatable from '../../components/Datatable.vue';
    import SmartSelect from '../../components/SmartSelect.vue';
    import ModalDelete from '../../components/ModalDelete.vue';
    export default {
        components: {
        //   LTable,
        //   ChartCard,
        //   StatsCard
            'datatable':Datatable,
            'smart-select':SmartSelect,
            'modal-delete':ModalDelete
        },
        data () {
            return {
                isMobile:false,
                nextUrl:null,
                prevUrl:null,
                passVisibleEdit:false,
                dataEdit:null,
                isEditIdKlienLength:false,
                isAddIdKlienLength:false,
                isAddName:false,
                isAddUsername:false,
                isAddPassword:false,
                isAddIdKlien:false,
                isEditPasswordLength:false,
                selectedDetail:0,
                isNewBadan:false,
                passVisible:false,
                itemToDelete:{},
                deleteId:0,
                users:[],
                searchValue:'',
                loadData:true,
                savingNewPengguna:false,
                errorNewUser:false,
                errorNewUserList:[],
                existingClientResult:[],
                newUserSaved:false,
                selectedClient:0,
                updateUserSaved:false,
                errorUserSaved:false,
                updateUserState:false,
                updateClientSaved:false,
                errorClientSaved:false,
                updateClientState:false,
                deleteUserState:false,
                userDeleted:false,
                failDeleteUser:false,

                selectedToDelete:0,
                selectedAdmin:0,
                existingClientQuery:{
                    firstNameClientQuery:'',
                    lastNameClientQuery:'',
                    legalNameClientQuery:'',
                    looking:false,
                    nextQueue:false,
                    waitForNext:false
                },
                //newClientCol:'col-4',
                updateClientCol:12,
                updateAdminCol:12,
                selectedTab:0,
                newUser:{
                    name:'',
                    username:'',
                    password:'',
                    role:'admin',
                    clientId:-1,
                    clientType:'existing',
                    newClient:{
                        IdKlien:'',
                        firstName:'',
                        lastName:'',
                        legalName:'',
                        telephonePemilik:'',
                        telephoneSecondaryPemilik:'',
                        telephonePengurus:'',
                        email:'',
                        npwp:'',
                        siup:'',
                        address:'',
                        identity:'KTP',
                        identityNo:'',
                        npwp:'',
                        type:'Badan'
                        // induk:'Perorangan'
                    }

                },
                newClientOption:{
                    identityTypes:[{label:'KTP',value:'KTP'},{label:'SIM',value:'SIM'},{label:'Passport',value:'Passport'}],
                    clientTypes:[{label:'Non Perorangan',value:'Badan'},{label:'Perorangan',value:'Perorangan'}],
                },
                formNewUserActive:false,
                userTableStructure:[
                    //label: nama heading, key: nama object property
                    {label:'No',key:null},
                    {label:'Username',key:null},
                    {label:'Nama Legal',key:null},
                    {label:'Role',key:null},
                    {label:'Tindakan',key:null}
                ],
                userRoleOptions:[]
            }
        },
        created(){
            console.clear()
            this.$reActivateAccess(this) /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
            console.log("user page")
            this.getUsers();
            this.setNPWP();
            this.isMobile = this.$isMobile
            window.addEventListener('resize', ()=>{
                console.log('screen update')
                this.isMobile = screen.width < 768
            });
            var roles =localStorage.getItem('role');
            console.log('role',roles);
            if (roles == 'client') {
                this.userRoleOptions = [
                    {label:'Pengguna',value:'client'},
                    {label:'Pengawas',value:'supervisor'},
                ];
            }else{
                this.userRoleOptions = [
                    {label:'Admin',value:'admin'},
                    {label:'Pengguna',value:'client'},
                    {label:'Pengawas',value:'supervisor'},
                    {label:'Teknisi',value:'petugas'},
                    {label:'Finance',value:'finance'},
                    {label:'Pajak',value:'tax'}
                ];
            }
            // var newData = [];
            // for(var x=0;x<100;x++){
            //     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
            // }
            // console.log(newData);
            // this.users = newData;
        },
        methods:{
            changePage(isNext){
                this.getUsers(isNext?this.nextUrl:this.prevUrl)
            },
            translateRole(role){
                var label="";
                switch(role){
                    case "client":
                        label = "Pelanggan";
                        break;
                    case "admin":
                        label = "Admin";
                        break;
                    case "master_admin":
                        label = "Master Admin";
                        break;
                    case "supervisor":
                        label = "Pengawas";
                        break;
                    case "petugas":
                        label = "Teknisi";
                        break;
                    case "finance":
                        label = "Finance";
                        break;
                    case "tax":
                        label = "Pajak";
                        break;
                }
                return label;
            },
            setNPWP(nodata=true,value=""){
                var init = "";
                if(!nodata){
                    init = value
                }
                for(var x=init.length;x<15;x++){
                    init +="0";
                }
                this.newUser.newClient.npwp = init.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
            },
            convertNewNPWP(){
                var el = document.getElementById('newNPWP');
                this.newUser.newClient.npwp=this.newUser.newClient.npwp.replace(/\./gi, '');
                this.newUser.newClient.npwp=this.newUser.newClient.npwp.replace(/\-/gi, '');
                var index = el.selectionStart;
            
                if(index==2||index==6||index==10||index==12||index==16){
                    index++
                }
                console.log(this.newUser.newClient.npwp)
                if(this.newUser.newClient.npwp.length>0 && this.newUser.newClient.npwp.length<15){
                    console.log(this.newUser.newClient.npwp.length)
                    for(var x=this.newUser.newClient.npwp.length;x<15;x++){
                        
                        this.newUser.newClient.npwp +="0";
                    }
                }
                if(this.newUser.newClient.npwp.length>15){
                    this.newUser.newClient.npwp = this.newUser.newClient.npwp.slice(0,15)
                }
                this.newUser.newClient.npwp = this.newUser.newClient.npwp.replace(/(\d{2})(\d{3})(\d{3})(\d{1})(\d{3})(\d{3})/, '$1.$2.$3.$4-$5.$6');
                
                setTimeout(() => {
                    
                    el.focus();
                    el.setSelectionRange(index, index);
                }, 0);
            },
            updateClientType(newValue){
                this.newUser.newClient.type=newValue
                if(newValue=="Perorangan"){
                    this.isNewBadan = true
                    
                }else{
                    this.isNewBadan = false
                    this.newUser.newClient.lastName = ""
                }
            },
            deleteResult(deleted){
                console.log(deleted)
                if(deleted){
                    this.getUsers();
                }
            },
            getUsers(url=(this.$baseUrl+'/api/master/pengguna')){
                this.loadData=true
                axios.get(url,{'headers':{
                        'Authorization':'Bearer '+localStorage.getItem('accessToken')
                    }
                }).then((result)=>{
                    console.log(result)
                    this.prevUrl = result.data.prev_page_url
                    this.nextUrl = result.data.next_page_url
                    this.users = result.data.data;
                    this.loadData=false
                }).catch((err)=>{
                    //check if token fail
                    if(err.response && err.response.status==401){
                        localStorage.removeItem('accessToken')
                    this.$router.push('/login')
                    }
                    console.log(err)
                    this.loadData=false
                })
            },
            saveNewUser(){
                this.isAddIdKlienLength=false
                if(this.newUser.newClient.IdKlien!="" && this.newUser.newClient.IdKlien.length<3 ){
                    this.isAddIdKlienLength=true
                    return;
                }
                this.isAddName=false
                    if(
                        this.newUser.name==''
                        ){
                        this.isAddName=true
                    }
                this.isAddPassword=false
                    if(
                        this.newUser.password==''
                        ){
                        this.isAddPassword=true
                    }
                this.isAddUsername=false
                    if(
                        this.newUser.username=='' 
                        ){
                        this.isAddUsername=true
                    }
                this.savingNewPengguna=true
                this.errorNewUser=false
                console.log(this.newUser)
                if(
                    this.newUser.name!='' && 
                    this.newUser.username!='' && 
                    this.newUser.password!='' && 
                    this.newUser.role!=''
                    ){
                    if(this.newUser.role=='client' && this.newUser.clientType=='new'){
                        if(
                        this.newUser.newClient.IdKlien=='' ||
                        this.newUser.newClient.firstName=='' ||
                        this.newUser.newClient.legalName==''
                        // this.newUser.newClient.firstName=='' ||
                        ){
                            this.errorNewUser = true;
                            this.savingNewPengguna=false;
                        }
                    }
                    console.log(this.newUser)
                    
                    axios.post(this.$baseUrl+'/api/master/pengguna',
                    {
                        name:this.newUser.name,
                        username:this.newUser.username,
                        password:this.newUser.password,
                        role:this.newUser.role,
                        client_type:this.newUser.clientType,
                        client_id:this.newUser.clientId,
                        customer_id:this.newUser.newClient.IdKlien,
                        first_name:this.newUser.newClient.firstName,
                        last_name:this.newUser.newClient.lastName,
                        legal_name:this.newUser.newClient.legalName,
                        telephone_pemilik:this.newUser.newClient.telephonePemilik,
                        telephone_pemilik_secondary:this.newUser.newClient.telephoneSecondaryPemilik,
                        telephone_pengurus:this.newUser.newClient.telephonePengurus,
                        email:this.newUser.newClient.email,
                        npwp:this.newUser.newClient.npwp,
                        siup:this.newUser.newClient.siup,
                        address:this.newUser.newClient.address,
                        identity:this.newUser.newClient.identity,
                        identity_no:this.newUser.newClient.identityNo,
                        type:this.newUser.newClient.type
                        // induk:this.newUser.newClient.induk,

                    },
                    {
                        'headers':
                        {
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        //console.log(result)
                        if(result.data.create){
                            this.getUsers();
                        }
                        this.newUser.name='',
                        this.newUser.username='',
                        this.newUser.password='',
                        this.newUser.role='admin',
                        this.savingNewPengguna=false
                        this.newUserSaved=true
                        this.resetFormNewClient()

                        setTimeout(() => {
                            this.newUserSaved=false
                            this.formNewUserActive=false
                        }, 1000);

                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                            localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        console.log(err.response)
                        this.errorNewUserList=[]
                        this.errorNewUserList=Object.values(err.response.data.errors)
                        console.log(this.errorNewUserList)
                        this.errorNewUser=true
                        this.savingNewPengguna=false
                    })
                }else{
                    this.errorNewUser=true
                    this.savingNewPengguna=false
                    this.errorNewUserList=[]
                    if(this.newUser.name==''){
                        this.errorNewUserList.push(["- Mohon Isi Nama"])
                    }
                    if(this.newUser.username==''){
                        this.errorNewUserList.push(["- Mohon Isi Username"])
                    }
                    if(this.newUser.password==''){
                        this.errorNewUserList.push(["- Mohon Isi Password"])
                    }
                    if(this.newUser.role==''){
                        this.errorNewUserList.push(["- Mohon Isi Role"])
                    }
                    if(this.newUser.role !=='admin' && this.newUser.clientType !="existing"){
                        if(this.newUser.newClient.IdKlien==''){
                            this.errorNewUserList.push(["- Mohon Isi ID Pelanggan"])
                        }
                        if(this.newUser.newClient.firstName==''){
                            this.errorNewUserList.push(["- Mohon Isi Nama"])
                        }
                        if(this.newUser.newClient.legalName==''){
                            this.errorNewUserList.push(["- Mohon Isi Nama Legal"])
                        }
                    }
                    console.log(this.errorNewUserList)
                }
            },
            newUsernameChange(){
                this.newUser.username = this.newUser.username.toUpperCase();
                this.newUser.password = this.newUser.username.toUpperCase();
            },
            resetFormNewClient(){
                this.newUser.name=""
                this.newUser.username=""
                this.newUser.password=""
                this.newUser.newClient.IdKlien=""
                this.newUser.newClient.firstName=""
                this.newUser.newClient.lastName=""
                this.newUser.newClient.legalName=""
                this.newUser.newClient.telephonePemilik=""
                this.newUser.newClient.telephoneSecondaryPemilik=""
                this.newUser.newClient.telephonePengurus=""
                this.newUser.newClient.email=""
                this.newUser.newClient.npwp=""
                this.newUser.newClient.siup=""
                this.newUser.newClient.address=""
                this.newUser.newClient.identityNo=""
            },
            deleteItem(idx){
                this.selectedToDelete=idx;
            },
            updateUserRoleValue(newValue){
                this.newUser.role=newValue
            },
            updateClientIdentityType(newValue){
                this.newUser.newClient.identity=newValue
            },
            // updateClientType(newValue){
            //     this.newUser.newClient.type=newValue
            // },
            updateClientIndukType(newValue){
                this.newUser.newClient.induk=newValue
            },
            recallClientSearch(){
                //this.existingClientQuery.waitForNext=true;
                console.log('asign new queue')
                setTimeout(() => {
                    console.log('recall')
                    if(!this.existingClientQuery.looking){
                        this.existingClientQuery.nextQueue=false;
                        this.searchExistingClientChangeEvent();
                    }else{
                        console.log('queue exist, current process still running, retry later')
                        this.recallClientSearch()
                    }
                }, 1000);
            },
            searchExistingClientChangeEvent(){
                if(this.existingClientQuery.looking && !this.existingClientQuery.nextQueue){
                    this.existingClientQuery.nextQueue=true;
                    this.recallClientSearch()
                    return;
                }else if(!this.existingClientQuery.looking && this.existingClientQuery.nextQueue){
                    return;
                }
                
                
                if(this.existingClientQuery.firstNameClientQuery!='' ||  this.existingClientQuery.lastNameClientQuery !="" || this.existingClientQuery.legalNameClientQuery!=''){
                    var data = {
                        first_name:this.existingClientQuery.firstNameClientQuery,
                        last_name:this.existingClientQuery.lastNameClientQuery,
                        legal_name:this.existingClientQuery.legalNameClientQuery,
                    };
                    console.log(data)
                    this.existingClientQuery.looking = true;
                    axios.post(this.$baseUrl+'/api/master/seeker/pengguna',
                    {
                        first_name:this.existingClientQuery.firstNameClientQuery,
                        last_name:this.existingClientQuery.lastNameClientQuery,
                        legal_name:this.existingClientQuery.legalNameClientQuery,
                    },
                    {
                        'headers':{
                            'Authorization':'Bearer '+localStorage.getItem('accessToken')
                        }
                    }).then((result)=>{
                        this.existingClientQuery.looking = false;
                        if(!this.existingClientQuery.nextQueue){
                            console.log('no Queue')
                            this.existingClientResult = result.data;
                        }
                        //console.log(result)
                    }).catch((err)=>{
                        //check if token fail
                        if(err.response && err.response.status==401){
                            localStorage.removeItem('accessToken')
                        this.$router.push('/login')
                        }
                        //console.log(err)
                        this.existingClientQuery.nextQueue = false;
                        this.existingClientQuery.looking=false;
                    })
                }else{
                    this.existingClientQuery.looking=false;
                    this.existingClientQuery.nextQueue = false;
                }
            },
            setNewClientId(newId,client=null){
                this.newUser.clientId = newId;
                if(client!=null){
                    this.newUser.name = client.first_name
                }
            },
            deleteClientData(){
              console.log('deleting data')
              this.deleteUserState=true;
              axios.delete(this.$baseUrl+'/api/master/pengguna/'+this.users[this.selectedToDelete].id,{
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                    this.deleteUserState=false;
                    this.userDeleted=true;
                    this.users.splice(this.selectedToDelete, 1);
                    
                  setTimeout(() => {
                      this.$bvModal.hide('modal-delete-user');
                      this.userDeleted=false;
                  }, 1500);
                  console.log('yaya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.deleteUserState=false;
                this.failDeleteUser=true;
                setTimeout(() => {
                      this.failDeleteUser=false;
                  }, 1500);
                console.log(err)
              })
            },
            updateUserData(){
              console.log('updating data')
              this.isEditPasswordLength=false
              if(this.users[this.selectedClient].password!=undefined&&this.users[this.selectedClient].password!="" && this.users[this.selectedClient].password.length<6 ){
                  this.isEditPasswordLength=true
                  return;
              }
              this.updateUserState=true;

                var tempData = {
                    name:this.users[this.selectedClient].name,
                    role:this.users[this.selectedClient].role,
                }

              if(
                  this.users[this.selectedClient].password!=undefined&&
                  this.users[this.selectedClient].password!=null&&
                  this.users[this.selectedClient].password!=''
                ){
                  tempData.password = this.users[this.selectedClient].password
              }
              axios.put(this.$baseUrl+'/api/master/pengguna/'+this.users[this.selectedClient].id,tempData,{
                  'headers':{
                    'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                  this.updateUserState=false;
                  this.updateUserSaved=true;
                  this.dataEdit=this.users[this.selectedClient]
                  this.users[this.selectedClient].password=""
                  setTimeout(() => {
                      this.updateUserSaved=false;
                      this.$bvModal.hide('modal-edit-user')
                  }, 1000);
                  console.log('ya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.updateUserState=false;
                this.errorUserSaved=true;
                setTimeout(() => {
                      this.errorUserSaved=false;
                  }, 1500);
                console.log(err)
              })
            },
            autoFillLegalName(){
                this.newUser.newClient.legalName = this.newUser.newClient.firstName +" "+ this.newUser.newClient.lastName
            },
            fillKlien(index,value){
              if(this.newHardwareQualityControl.noSN[index]!=undefined && this.newHardwareQualityControl.noSN[index]!=null && this.newHardwareQualityControl.noSN[index]!=""){
                console.log("contain id")
                this.newHardwareQualityControl.hardwareId[index]=value
              }else{
                console.log("contain none")
                this.newHardwareQualityControl.hardwareId[index]=null
              }
            },
            updateClientData(){
              console.log('updating data')
            //   this.isEditIdKlienLength=false
            //   if(this.users[this.selectedClient].client.customer_id!="" && this.users[this.selectedClient].client.customer_id.length<3 ){
            //       this.isEditIdKlienLength=true
            //       return;
            //   }
              this.updateClientState=true;
              axios.put(this.$baseUrl+'/api/master/klien/'+this.users[this.selectedClient].client.id,
              {
                customer_id:this.users[this.selectedClient].client.customer_id,
                first_name:this.users[this.selectedClient].client.first_name,
                last_name:this.users[this.selectedClient].client.last_name,
                legal_name:this.users[this.selectedClient].client.legal_name,
                telephone_pemilik:this.users[this.selectedClient].client.telephone_pemilik,
                telephone_pemilik_secondary:this.users[this.selectedClient].client.telephone_pemilik_secondary,
                telephone_pengurus:this.users[this.selectedClient].client.telephone_pengurus,
                email:this.users[this.selectedClient].client.email,
                npwp:this.users[this.selectedClient].client.npwp,
                siup:this.users[this.selectedClient].client.siup,
                address:this.users[this.selectedClient].client.address,
                identity:this.users[this.selectedClient].client.identity,
                identity_no:this.users[this.selectedClient].client.identity_no,
                type:this.users[this.selectedClient].client.type,
                induk:this.users[this.selectedClient].client.induk,
              },
              {
                  'headers':{
                      'Authorization':'Bearer '+localStorage.getItem('accessToken')
                  }
              }).then((result)=>{
                if(result.status==200){
                    this.dataEdit = Object.assign({},this.users[this.selectedClient])
                    this.updateClientState=false;
                    this.updateClientSaved=true;
                    setTimeout(() => {
                        this.updateClientSaved=false;
                        this.$bvModal.hide('modal-edit-user')
                    }, 1000);
                    console.log('ya berhasil')
                }
              }).catch((err)=>{
                //check if token fail
                if(err.response && err.response.status==401){
                    localStorage.removeItem('accessToken')
                this.$router.push('/login')
                }
                this.updateClientState=false;
                this.errorClientSaved=true;
                setTimeout(() => {
                      this.errorClientSaved=false;
                  }, 1000);
                console.log(err.response)
              })
            },
            detailModalClose(mdl){
              if(this.updateUserState || this.updateClientState){
                console.log('updating')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-detail-pengguna');
              }
            },
            editModalClose(mdl){
                this.$set(this.users, this.selectedClient, this.dataEdit)
                this.dataEdit = Object.assign({},null)
              if(this.updateUserState || this.updateClientState){
                console.log('updating')
                mdl.preventDefault()
              }else{
                console.log('closing')
                //mdl.hide('modal-edit-user');
              }
            },
            deleteModalClose(mdl){
              if(this.deleteUserState){
                console.log('deleting')
                mdl.preventDefault()
              }else{
                console.log('closing')
                mdl.hide('modal-delete-user');
              }
            }
            
        },
    }
</script>
<style scoped>
/* .modal.show .modal-dialog{
    transform:none;
    -webkit-transform: none;
} */
.btn {
    padding:2px 6px;
}
::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 10.5rem);
    height: 447px;
}
::v-deep .modal.show .modal-dialog{
    transform:none;
    -webkit-transform: none;
}
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
    width: 50%;
}
/*Start:hide top and bottom with type=number*/
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
/*End:hide top and bottom with type=number*/

.field-icon {
  float: right;
  margin-right: 10px;
  margin-top: -30px;
  position: relative;
  z-index: 2;
}
.field-icon-update {
  float: right;
  margin-right: 10px;
  margin-top: -35px;
  position: relative;
  z-index: 2;
}
</style>
